import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { APP_SETTINGS, ToastConfigService } from '@services';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { SpinnerService } from '../../../core/services/spinner/spinner.service';
import { CmsNavbarService } from '../../cms-navbar/cms-navbar.service';
import { AdminService } from '../admin.service';
import { FormsModule } from '@angular/forms';
import { NgFor, NgIf } from '@angular/common';

@Component({
    selector: 'app-add-bulletin-info',
    templateUrl: './add-bulletin-info.component.html',
    styleUrls: ['./add-bulletin-info.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        FormsModule,
        NgFor,
        NgIf,
    ],
})
export class AddBulletinInfoComponent implements OnInit {

  private subscriptions: ISubscription[];
  public mainGroupList = [];
  public makeList = [];

  public adminPassword;
  public inputGroup;
  public inputDate;
  public tkrCode = '';
  public isTakataRecall = false;
  public inputMake;
  public bulletinNumber = '';
  public bulletinType;
  public description = '';
  public setDateFlag: boolean = false;

  public uploadedFile = null;
  public uploadedFileName = 'No File Selected';
  // public uploadedFiles = [];
  // public uploadedFileNames: string[] = ['No File Selected'];

  public uploadedSupportingFile;
  public uploadedSupprtingFileName = 'No File Selected';
  public uploadedSupportingFiles = [];
  public uploadedSupportingFileNames: string[] = [];

  public errorMessage = '';

  constructor(
    private cmsNavbarService: CmsNavbarService,
    private toastService: ToastConfigService,
    private adminService: AdminService,
    private spinnerService: SpinnerService
  ) { }

  ngOnInit() {
    this.subscriptions = [];
    if (APP_SETTINGS.isMOTORRAD === "true") {
      this.mainGroupList = APP_SETTINGS.motorradMainGroupList;
    }
    else {
      this.mainGroupList = APP_SETTINGS.mainGroupList;
    }
    this.subscriptions.push(this.cmsNavbarService.getAllMakeList().subscribe(data => {
      this.makeList = data.filter(make => (make['makeName'] === 'BMW' || make['makeName'] === 'MINI'));
    }));
  }
  fileUpload(fileObj) {
    if (fileObj && fileObj.target.files.length > 0) {
      const file = fileObj.target.files[0];
      this.uploadedFile = file;
      this.uploadedFileName = file.name;
    }
  }

  fileUploadSupporting(fileObj) {
    // if (fileObj && fileObj.target.files.length > 0) {
    //   const file = fileObj.target.files[0];
    //   this.uploadedSupportingFiles = file;
    //   this.uploadedSupportingFileNames = file.name;
    // }
    // If user selects multiple files, the length with be > 1
    // Single file at a time may require special handling
    if (fileObj && fileObj.target.files.length > 0) {
      const files = fileObj.target.files;

      for (let i = 0; i < files.length; i++) {
        if (this.uploadedSupportingFiles == null) {
          this.uploadedSupportingFiles = [];
        }
        const name = files[i].name;
        let foundIt = 0;
        for (let j = 0; j < this.uploadedSupportingFiles.length; j++) {
          if (this.uploadedSupportingFiles[j].name === name) {
            foundIt = 1;
            break;
          }
        }


        if (foundIt === 0) {
          this.uploadedSupportingFileNames.push(files[i].name);
          this.uploadedSupportingFiles.push(files[i]);
        }
      }

      /* Original COde
      this.uploadedSupportingFiles = files;
      // this.uploadedArbortextFileNames = [];
      Object.keys(this.uploadedSupportingFiles).forEach(key => {
        this.uploadedSupportingFileNames.push(this.uploadedSupportingFiles[key].name);
      });
      */
    }
  }
  checkInputDate() {
    if (this.inputDate == null) {
      this.inputDate = this.setDefaultDate();
    }
    if (this.setDateFlag === true && this.inputDate['formatted'] == null) {
      // no action
    } else if (this.inputDate['formatted'] == null && this.setDateFlag === false) {
      this.inputDate = this.setDefaultDate();
    } else {
      this.inputDate = this.inputDate['formatted'];
      this.setDateFlag = true;
    }
  }

  setDefaultDate(): string {
    let d = new Date();
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    let year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  }

  submitBulletin() {
    this.spinnerService.show('bmwSpinner');
    const formData = new FormData();
    this.checkInputDate();
    formData.append('bulletinType', this.bulletinType.toUpperCase());
    formData.append('description', this.description);
    formData.append('makeName', this.inputMake.makeName);
    let mainGroupNum = '';
    if (this.inputGroup) {
      const matchString = this.inputGroup.match(/\[(.*?)\]/)[1];
      if (APP_SETTINGS.isMOTORRAD === 'true') {
        mainGroupNum = matchString;
      } else {
      mainGroupNum = +matchString < 10 ? '0' + matchString : matchString;
      }
    }

    formData.append('adminPassword', this.adminPassword);
    formData.append('mainGroupId', mainGroupNum);
    formData.append('isTakataRecallType', this.isTakataRecall.toString());
    formData.append('takataRecallCode', this.tkrCode);
    formData.append('releaseDate', this.inputDate);
    if (this.uploadedFile !== null) {
      formData.append('xmlDetailFile', this.uploadedFile, this.uploadedFile.name);
    }
    Object.keys(this.uploadedSupportingFiles).forEach(key => {
      formData.append('bulletinFile', this.uploadedSupportingFiles[key], this.uploadedSupportingFiles[key].name);
      // this.uploadedFileNames.push(this.uploadedFiles[key].name);
    });
    // formData.append('xmlDetailFile', this.uploadedArbortextFile, this.uploadedArbortextFile.name);

    this.subscriptions.push(this.adminService.createNewBulletin(formData, this.bulletinNumber).subscribe(data => {
      if (data) {
        this.spinnerService.hide('bmwSpinner');
        this.errorMessage = '';
        this.toastService.popToast('Submitted for Approval');
        this.clearData();
      }
    },
      error => {
        this.spinnerService.hide('bmwSpinner');
        this.errorMessage = error.error.message;
      }
    ));
  }
  formatBulletinNumber(event: any) {
    if (event.key == "ArrowLeft" || event.key == "ArrowRight" || event.keyCode == 8 || event.keyCode == 65 || event.keyCode == 67 || event.keyCode == 17) { return };
    let tempInput = this.bulletinNumber;
    let split = 2;
    let chunk = [];
    tempInput = tempInput.replace(/[\D\s\._\-]+/g, "");

    for (let i = 0; i < this.bulletinNumber.length; i += split) {
      chunk.push(tempInput.substr(i, split));
    }
    tempInput = chunk.join(' ').trim();
    this.bulletinNumber = tempInput.slice(0, 8);
  }
  clearData() {
    this.adminPassword = '';
    this.inputGroup = '';
    this.description = '';
    this.bulletinNumber = '';
    this.isTakataRecall = false;
    this.tkrCode = '';
    this.uploadedFile = null;
    this.uploadedFileName = 'No File Choosen';
    this.uploadedSupportingFileNames = [];
    this.uploadedSupportingFiles = [];
  }
}
